import { getVal, isLoaded } from 'react-redux-firebase';
import dayjs from 'dayjs';
import { createSelector } from 'reselect';

import { STORE_TIMESLOT_AS } from './constants';
/**
 * Get start of day
 */
export const getStartOfDay = (state, props) => dayjs(props.date).startOf('day');

/**
 * Time slots input selector
 * @param {Object} state component state
 */
const getTimeslots = state => {
  const value = getVal(state.firebase.ordered, STORE_TIMESLOT_AS);
  return isLoaded(value) ? value : false;
};

const getFilter = (state, props) => props.timeslotFilter;

export const getFilteredTimeslots = createSelector(
  [getTimeslots, getFilter],
  (timeslots, filter) => {
    if (!timeslots || !filter) {
      return timeslots;
    }
    return timeslots.filter(filter);
  }
);
